/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.0.14.0 (NJsonSchema v9.13.18.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class ClientBase {
  protected async transformOptions(options: RequestInit) {
    options.credentials = 'same-origin';

    // Check if document is defined (i.e. in the browser or in node.js).
    const isBrowser = typeof document !== "undefined";
    if (!isBrowser) {
      return Promise.resolve(options);
    }

    const input: any = document.getElementsByName('__RequestVerificationToken')[0];
    if (input) {
      Object.assign(options.headers || {}, {'X-CSRF-TOKEN-ORDERFORM': input.value});
    }

    return Promise.resolve(options);
  }

  protected transformResult(_url: string, response: Response, processor: (response: Response) => any) {
    return processor(response);
  }
}

export interface IDefaultClient {
    index(cart: string, campaignCode: string | null | undefined, inWeekSale: boolean | undefined, skipRecipeSelection: number | undefined, hideAvailableRecipes: number | undefined, excludeBufferDates: number | undefined, recipeSelections: string | null | undefined): Promise<IndexModel | null>;
    index2(sku: string, cart: string | null, buffer: boolean | null, inWeekSale: boolean | null, ss: number | null, har: number | null, ebd: number | null, prefs: string | null, campaignCode: string | null, rs: string | null | undefined): Promise<IndexModel | null>;
    spa(brand: Brand | null): Promise<FileResponse | null>;
    spa2(brand: Brand | null): Promise<FileResponse | null>;
}

export class DefaultClient extends ClientBase implements IDefaultClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    index(cart: string, campaignCode: string | null | undefined, inWeekSale: boolean | undefined, skipRecipeSelection: number | undefined, hideAvailableRecipes: number | undefined, excludeBufferDates: number | undefined, recipeSelections: string | null | undefined): Promise<IndexModel | null> {
        let url_ = this.baseUrl + "/order?";
        if (cart === undefined || cart === null)
            throw new Error("The parameter 'cart' must be defined and cannot be null.");
        else
            url_ += "cart=" + encodeURIComponent("" + cart) + "&"; 
        if (campaignCode !== undefined)
            url_ += "campaignCode=" + encodeURIComponent("" + campaignCode) + "&"; 
        if (inWeekSale === null)
            throw new Error("The parameter 'inWeekSale' cannot be null.");
        else if (inWeekSale !== undefined)
            url_ += "inWeekSale=" + encodeURIComponent("" + inWeekSale) + "&"; 
        if (skipRecipeSelection === null)
            throw new Error("The parameter 'skipRecipeSelection' cannot be null.");
        else if (skipRecipeSelection !== undefined)
            url_ += "skipRecipeSelection=" + encodeURIComponent("" + skipRecipeSelection) + "&"; 
        if (hideAvailableRecipes === null)
            throw new Error("The parameter 'hideAvailableRecipes' cannot be null.");
        else if (hideAvailableRecipes !== undefined)
            url_ += "hideAvailableRecipes=" + encodeURIComponent("" + hideAvailableRecipes) + "&"; 
        if (excludeBufferDates === null)
            throw new Error("The parameter 'excludeBufferDates' cannot be null.");
        else if (excludeBufferDates !== undefined)
            url_ += "excludeBufferDates=" + encodeURIComponent("" + excludeBufferDates) + "&"; 
        if (recipeSelections !== undefined)
            url_ += "recipeSelections=" + encodeURIComponent("" + recipeSelections) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<IndexModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <IndexModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndexModel | null>(<any>null);
    }

    index2(sku: string, cart: string | null, buffer: boolean | null, inWeekSale: boolean | null, ss: number | null, har: number | null, ebd: number | null, prefs: string | null, campaignCode: string | null, rs: string | null | undefined): Promise<IndexModel | null> {
        let url_ = this.baseUrl + "/order/{sku}?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        if (cart === undefined)
            throw new Error("The parameter 'cart' must be defined.");
        else
            url_ += "cart=" + encodeURIComponent("" + cart) + "&"; 
        if (buffer === undefined)
            throw new Error("The parameter 'buffer' must be defined.");
        else
            url_ += "buffer=" + encodeURIComponent("" + buffer) + "&"; 
        if (inWeekSale === undefined)
            throw new Error("The parameter 'inWeekSale' must be defined.");
        else
            url_ += "inWeekSale=" + encodeURIComponent("" + inWeekSale) + "&"; 
        if (ss === undefined)
            throw new Error("The parameter 'ss' must be defined.");
        else
            url_ += "ss=" + encodeURIComponent("" + ss) + "&"; 
        if (har === undefined)
            throw new Error("The parameter 'har' must be defined.");
        else
            url_ += "har=" + encodeURIComponent("" + har) + "&"; 
        if (ebd === undefined)
            throw new Error("The parameter 'ebd' must be defined.");
        else
            url_ += "ebd=" + encodeURIComponent("" + ebd) + "&"; 
        if (prefs === undefined)
            throw new Error("The parameter 'prefs' must be defined.");
        else
            url_ += "prefs=" + encodeURIComponent("" + prefs) + "&"; 
        if (campaignCode === undefined)
            throw new Error("The parameter 'campaignCode' must be defined.");
        else
            url_ += "campaignCode=" + encodeURIComponent("" + campaignCode) + "&"; 
        if (rs !== undefined)
            url_ += "rs=" + encodeURIComponent("" + rs) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIndex2(_response);
        });
    }

    protected processIndex2(response: Response): Promise<IndexModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <IndexModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndexModel | null>(<any>null);
    }

    spa(brand: Brand | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/order/success?";
        if (brand === undefined)
            throw new Error("The parameter 'brand' must be defined.");
        else
            url_ += "brand=" + encodeURIComponent("" + brand) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSpa(_response);
        });
    }

    protected processSpa(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    spa2(brand: Brand | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/order/failure?";
        if (brand === undefined)
            throw new Error("The parameter 'brand' must be defined.");
        else
            url_ += "brand=" + encodeURIComponent("" + brand) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSpa2(_response);
        });
    }

    protected processSpa2(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export interface IAddressClient {
    suggestAddress(address: string | null): Promise<AddressSuggestionResponse[] | null>;
    verifyAddress(addressSuggestionId: number): Promise<AddressSummary | null>;
}

export class AddressClient extends ClientBase implements IAddressClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    suggestAddress(address: string | null): Promise<AddressSuggestionResponse[] | null> {
        let url_ = this.baseUrl + "/api/Address/search?";
        if (address === undefined)
            throw new Error("The parameter 'address' must be defined.");
        else
            url_ += "address=" + encodeURIComponent("" + address) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSuggestAddress(_response);
        });
    }

    protected processSuggestAddress(response: Response): Promise<AddressSuggestionResponse[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AddressSuggestionResponse[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressSuggestionResponse[] | null>(<any>null);
    }

    verifyAddress(addressSuggestionId: number): Promise<AddressSummary | null> {
        let url_ = this.baseUrl + "/api/Address/verify-address?";
        if (addressSuggestionId === undefined || addressSuggestionId === null)
            throw new Error("The parameter 'addressSuggestionId' must be defined and cannot be null.");
        else
            url_ += "addressSuggestionId=" + encodeURIComponent("" + addressSuggestionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyAddress(_response);
        });
    }

    protected processVerifyAddress(response: Response): Promise<AddressSummary | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AddressSummary>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressSummary | null>(<any>null);
    }
}

export interface ICustomerClient {
    validateEmailAddress(address: string | null): Promise<void>;
    createLead(request: DraftLeadPayload | null): Promise<DraftLeadResponse | null>;
}

export class CustomerClient extends ClientBase implements ICustomerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    validateEmailAddress(address: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/Customer/validate?";
        if (address === undefined)
            throw new Error("The parameter 'address' must be defined.");
        else
            url_ += "address=" + encodeURIComponent("" + address) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateEmailAddress(_response);
        });
    }

    protected processValidateEmailAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    createLead(request: DraftLeadPayload | null): Promise<DraftLeadResponse | null> {
        let url_ = this.baseUrl + "/api/Customer/create-lead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateLead(_response);
        });
    }

    protected processCreateLead(response: Response): Promise<DraftLeadResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DraftLeadResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DraftLeadResponse | null>(<any>null);
    }
}

export interface IDeliveryClient {
    getDeliveryDatesForAddressAndSku(id: number, productOptionSku: string, isOneOffBufferSale: boolean | undefined, excludeBufferDate: boolean | undefined): Promise<DeliveryDateSet | null>;
}

export class DeliveryClient extends ClientBase implements IDeliveryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getDeliveryDatesForAddressAndSku(id: number, productOptionSku: string, isOneOffBufferSale: boolean | undefined, excludeBufferDate: boolean | undefined): Promise<DeliveryDateSet | null> {
        let url_ = this.baseUrl + "/api/Delivery/{id}/dates/product/{productOptionSku}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (productOptionSku === undefined || productOptionSku === null)
            throw new Error("The parameter 'productOptionSku' must be defined.");
        url_ = url_.replace("{productOptionSku}", encodeURIComponent("" + productOptionSku)); 
        if (isOneOffBufferSale === null)
            throw new Error("The parameter 'isOneOffBufferSale' cannot be null.");
        else if (isOneOffBufferSale !== undefined)
            url_ += "isOneOffBufferSale=" + encodeURIComponent("" + isOneOffBufferSale) + "&"; 
        if (excludeBufferDate === null)
            throw new Error("The parameter 'excludeBufferDate' cannot be null.");
        else if (excludeBufferDate !== undefined)
            url_ += "excludeBufferDate=" + encodeURIComponent("" + excludeBufferDate) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeliveryDatesForAddressAndSku(_response);
        });
    }

    protected processGetDeliveryDatesForAddressAndSku(response: Response): Promise<DeliveryDateSet | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DeliveryDateSet>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeliveryDateSet | null>(<any>null);
    }
}

export interface IProductClient {
    loadProduct(id: number): Promise<ProductResponse | null>;
    loadProductBySku(sku: string): Promise<ProductResponse | null>;
    loadAllProducts(): Promise<ProductResponse[] | null>;
    loadProductAddons(productOptionSku: string): Promise<ProductOptionStockAvailability[] | null>;
    loadExtras(): Promise<ProductOptionResponse[] | null>;
    managedStockIsAvailableForSku(sku: string): Promise<boolean>;
    managedStockIsAvailableForSelectedSkus(request: MultipleSkuRequest | null): Promise<ProductOptionStockAvailability[] | null>;
    getBufferStockForWeekAndAddress(weekStarting: Date | null | undefined, addressId: number | null | undefined): Promise<ProductOptionStockAvailability[] | null>;
}

export class ProductClient extends ClientBase implements IProductClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    loadProduct(id: number): Promise<ProductResponse | null> {
        let url_ = this.baseUrl + "/api/Product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoadProduct(_response);
        });
    }

    protected processLoadProduct(response: Response): Promise<ProductResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductResponse | null>(<any>null);
    }

    loadProductBySku(sku: string): Promise<ProductResponse | null> {
        let url_ = this.baseUrl + "/api/Product/bysku/{sku}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoadProductBySku(_response);
        });
    }

    protected processLoadProductBySku(response: Response): Promise<ProductResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductResponse | null>(<any>null);
    }

    loadAllProducts(): Promise<ProductResponse[] | null> {
        let url_ = this.baseUrl + "/api/Product/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoadAllProducts(_response);
        });
    }

    protected processLoadAllProducts(response: Response): Promise<ProductResponse[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductResponse[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductResponse[] | null>(<any>null);
    }

    loadProductAddons(productOptionSku: string): Promise<ProductOptionStockAvailability[] | null> {
        let url_ = this.baseUrl + "/api/Product/{productOptionSku}/addons";
        if (productOptionSku === undefined || productOptionSku === null)
            throw new Error("The parameter 'productOptionSku' must be defined.");
        url_ = url_.replace("{productOptionSku}", encodeURIComponent("" + productOptionSku)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoadProductAddons(_response);
        });
    }

    protected processLoadProductAddons(response: Response): Promise<ProductOptionStockAvailability[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductOptionStockAvailability[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductOptionStockAvailability[] | null>(<any>null);
    }

    loadExtras(): Promise<ProductOptionResponse[] | null> {
        let url_ = this.baseUrl + "/api/Product/extras";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoadExtras(_response);
        });
    }

    protected processLoadExtras(response: Response): Promise<ProductOptionResponse[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductOptionResponse[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductOptionResponse[] | null>(<any>null);
    }

    managedStockIsAvailableForSku(sku: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Product/stock/{sku}/available";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processManagedStockIsAvailableForSku(_response);
        });
    }

    protected processManagedStockIsAvailableForSku(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    managedStockIsAvailableForSelectedSkus(request: MultipleSkuRequest | null): Promise<ProductOptionStockAvailability[] | null> {
        let url_ = this.baseUrl + "/api/Product/stock/many/available";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processManagedStockIsAvailableForSelectedSkus(_response);
        });
    }

    protected processManagedStockIsAvailableForSelectedSkus(response: Response): Promise<ProductOptionStockAvailability[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductOptionStockAvailability[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductOptionStockAvailability[] | null>(<any>null);
    }

    getBufferStockForWeekAndAddress(weekStarting: Date | null | undefined, addressId: number | null | undefined): Promise<ProductOptionStockAvailability[] | null> {
        let url_ = this.baseUrl + "/api/Product/stock/buffer?";
        if (weekStarting !== undefined)
            url_ += "weekStarting=" + encodeURIComponent(weekStarting ? "" + weekStarting.toJSON() : "") + "&"; 
        if (addressId !== undefined)
            url_ += "addressId=" + encodeURIComponent("" + addressId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBufferStockForWeekAndAddress(_response);
        });
    }

    protected processGetBufferStockForWeekAndAddress(response: Response): Promise<ProductOptionStockAvailability[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductOptionStockAvailability[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductOptionStockAvailability[] | null>(<any>null);
    }
}

export interface ISubscriptionClient {
    createSubscription(request: SubscriptionRequest | null): Promise<PurchaseResponse | null>;
    createSubscriptionWithLead(request: SubscriptionRequest | null): Promise<PurchaseResponse | null>;
    validateCode(cartId: string, code: string): Promise<ValidateCodeResponse | null>;
    calculateCost(request: CalculateCostRequestBody | null): Promise<CalculateCostResponse | null>;
}

export class SubscriptionClient extends ClientBase implements ISubscriptionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    createSubscription(request: SubscriptionRequest | null): Promise<PurchaseResponse | null> {
        let url_ = this.baseUrl + "/api/Subscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSubscription(_response);
        });
    }

    protected processCreateSubscription(response: Response): Promise<PurchaseResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PurchaseResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseResponse | null>(<any>null);
    }

    createSubscriptionWithLead(request: SubscriptionRequest | null): Promise<PurchaseResponse | null> {
        let url_ = this.baseUrl + "/api/Subscription/subscription-with-lead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSubscriptionWithLead(_response);
        });
    }

    protected processCreateSubscriptionWithLead(response: Response): Promise<PurchaseResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PurchaseResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <CreateSubscriptionErrorCode>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseResponse | null>(<any>null);
    }

    validateCode(cartId: string, code: string): Promise<ValidateCodeResponse | null> {
        let url_ = this.baseUrl + "/api/Subscription/cart/{cartId}/validate/{code}";
        if (cartId === undefined || cartId === null)
            throw new Error("The parameter 'cartId' must be defined.");
        url_ = url_.replace("{cartId}", encodeURIComponent("" + cartId)); 
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateCode(_response);
        });
    }

    protected processValidateCode(response: Response): Promise<ValidateCodeResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ValidateCodeResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateCodeResponse | null>(<any>null);
    }

    calculateCost(request: CalculateCostRequestBody | null): Promise<CalculateCostResponse | null> {
        let url_ = this.baseUrl + "/api/Subscription/calculate/cost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateCost(_response);
        });
    }

    protected processCalculateCost(response: Response): Promise<CalculateCostResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CalculateCostResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculateCostResponse | null>(<any>null);
    }
}

export interface IVoucherClient {
    createVoucher(request: CreateVoucherRequest | null): Promise<VoucherPaymentRedirectResponse | null>;
    processPaymentResult(result: string | null): Promise<VoucherPaymentResult | null>;
    download(id: string): Promise<FileResponse | null>;
    isMultipleVoucherGroup(id: string): Promise<boolean>;
}

export class VoucherClient extends ClientBase implements IVoucherClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    createVoucher(request: CreateVoucherRequest | null): Promise<VoucherPaymentRedirectResponse | null> {
        let url_ = this.baseUrl + "/api/Voucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateVoucher(_response);
        });
    }

    protected processCreateVoucher(response: Response): Promise<VoucherPaymentRedirectResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <VoucherPaymentRedirectResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoucherPaymentRedirectResponse | null>(<any>null);
    }

    processPaymentResult(result: string | null): Promise<VoucherPaymentResult | null> {
        let url_ = this.baseUrl + "/api/Voucher/payment?";
        if (result === undefined)
            throw new Error("The parameter 'result' must be defined.");
        else
            url_ += "result=" + encodeURIComponent("" + result) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessPaymentResult(_response);
        });
    }

    protected processProcessPaymentResult(response: Response): Promise<VoucherPaymentResult | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <VoucherPaymentResult>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoucherPaymentResult | null>(<any>null);
    }

    download(id: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Voucher/download/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    isMultipleVoucherGroup(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Voucher/ismultiple/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsMultipleVoucherGroup(_response);
        });
    }

    protected processIsMultipleVoucherGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export interface IRecipeClient {
    upcomingReadyMadeMealRecipes(): Promise<RecipeResponse | null>;
    upcomingSelectionRecipes(sku: string): Promise<RecipeResponse | null>;
    availableRecipesForSkuAndWeek(sku: string, week: Date): Promise<RecipeDto[] | null>;
    getRecipeById(recipeId: number): Promise<RecipeDetailResponse | null>;
    /**
     * @param recipeId (optional) 
     * @deprecated
     */
    getRecipeByRVP(recipeNumber: string, recipeVersion: string, partition: string, recipeId: number | null | undefined): Promise<RecipeDetailResponse | null>;
    getRecipeDetail(recipeNumber: string, recipeVersion: string, partition: string, deliveryWeek: Date): Promise<RecipeDetailResponse2 | null>;
    getRecipeByRVPForWeek(recipeNumber: string, recipeVersion: string, partition: string, week: Date, recipeId: number | null | undefined): Promise<RecipeDetailResponse | null>;
}

export class RecipeClient extends ClientBase implements IRecipeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    upcomingReadyMadeMealRecipes(): Promise<RecipeResponse | null> {
        let url_ = this.baseUrl + "/api/Recipe/upcoming-rmm-recipes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpcomingReadyMadeMealRecipes(_response);
        });
    }

    protected processUpcomingReadyMadeMealRecipes(response: Response): Promise<RecipeResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeResponse | null>(<any>null);
    }

    upcomingSelectionRecipes(sku: string): Promise<RecipeResponse | null> {
        let url_ = this.baseUrl + "/api/Recipe/upcoming-recipes/{sku}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpcomingSelectionRecipes(_response);
        });
    }

    protected processUpcomingSelectionRecipes(response: Response): Promise<RecipeResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeResponse | null>(<any>null);
    }

    availableRecipesForSkuAndWeek(sku: string, week: Date): Promise<RecipeDto[] | null> {
        let url_ = this.baseUrl + "/api/Recipe/upcoming-recipes/{sku}/{week}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent(week ? "" + week.toJSON() : "null")); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAvailableRecipesForSkuAndWeek(_response);
        });
    }

    protected processAvailableRecipesForSkuAndWeek(response: Response): Promise<RecipeDto[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeDto[] | null>(<any>null);
    }

    getRecipeById(recipeId: number): Promise<RecipeDetailResponse | null> {
        let url_ = this.baseUrl + "/api/Recipe/details/{recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecipeById(_response);
        });
    }

    protected processGetRecipeById(response: Response): Promise<RecipeDetailResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeDetailResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeDetailResponse | null>(<any>null);
    }

    /**
     * @param recipeId (optional) 
     * @deprecated
     */
    getRecipeByRVP(recipeNumber: string, recipeVersion: string, partition: string, recipeId: number | null | undefined): Promise<RecipeDetailResponse | null> {
        let url_ = this.baseUrl + "/api/Recipe/details/{recipeNumber}/{recipeVersion}/{partition}?";
        if (recipeNumber === undefined || recipeNumber === null)
            throw new Error("The parameter 'recipeNumber' must be defined.");
        url_ = url_.replace("{recipeNumber}", encodeURIComponent("" + recipeNumber)); 
        if (recipeVersion === undefined || recipeVersion === null)
            throw new Error("The parameter 'recipeVersion' must be defined.");
        url_ = url_.replace("{recipeVersion}", encodeURIComponent("" + recipeVersion)); 
        if (partition === undefined || partition === null)
            throw new Error("The parameter 'partition' must be defined.");
        url_ = url_.replace("{partition}", encodeURIComponent("" + partition)); 
        if (recipeId !== undefined)
            url_ += "recipeId=" + encodeURIComponent("" + recipeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecipeByRVP(_response);
        });
    }

    protected processGetRecipeByRVP(response: Response): Promise<RecipeDetailResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeDetailResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeDetailResponse | null>(<any>null);
    }

    getRecipeDetail(recipeNumber: string, recipeVersion: string, partition: string, deliveryWeek: Date): Promise<RecipeDetailResponse2 | null> {
        let url_ = this.baseUrl + "/api/Recipe/recipe-details/{recipeNumber}/{recipeVersion}/{partition}/{deliveryWeek}";
        if (recipeNumber === undefined || recipeNumber === null)
            throw new Error("The parameter 'recipeNumber' must be defined.");
        url_ = url_.replace("{recipeNumber}", encodeURIComponent("" + recipeNumber)); 
        if (recipeVersion === undefined || recipeVersion === null)
            throw new Error("The parameter 'recipeVersion' must be defined.");
        url_ = url_.replace("{recipeVersion}", encodeURIComponent("" + recipeVersion)); 
        if (partition === undefined || partition === null)
            throw new Error("The parameter 'partition' must be defined.");
        url_ = url_.replace("{partition}", encodeURIComponent("" + partition)); 
        if (deliveryWeek === undefined || deliveryWeek === null)
            throw new Error("The parameter 'deliveryWeek' must be defined.");
        url_ = url_.replace("{deliveryWeek}", encodeURIComponent(deliveryWeek ? "" + deliveryWeek.toJSON() : "null")); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecipeDetail(_response);
        });
    }

    protected processGetRecipeDetail(response: Response): Promise<RecipeDetailResponse2 | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeDetailResponse2>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeDetailResponse2 | null>(<any>null);
    }

    getRecipeByRVPForWeek(recipeNumber: string, recipeVersion: string, partition: string, week: Date, recipeId: number | null | undefined): Promise<RecipeDetailResponse | null> {
        let url_ = this.baseUrl + "/api/Recipe/details/{recipeNumber}/{recipeVersion}/{partition}/{week}?";
        if (recipeNumber === undefined || recipeNumber === null)
            throw new Error("The parameter 'recipeNumber' must be defined.");
        url_ = url_.replace("{recipeNumber}", encodeURIComponent("" + recipeNumber)); 
        if (recipeVersion === undefined || recipeVersion === null)
            throw new Error("The parameter 'recipeVersion' must be defined.");
        url_ = url_.replace("{recipeVersion}", encodeURIComponent("" + recipeVersion)); 
        if (partition === undefined || partition === null)
            throw new Error("The parameter 'partition' must be defined.");
        url_ = url_.replace("{partition}", encodeURIComponent("" + partition)); 
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent(week ? "" + week.toJSON() : "null")); 
        if (recipeId !== undefined)
            url_ += "recipeId=" + encodeURIComponent("" + recipeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecipeByRVPForWeek(_response);
        });
    }

    protected processGetRecipeByRVPForWeek(response: Response): Promise<RecipeDetailResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeDetailResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeDetailResponse | null>(<any>null);
    }
}

export interface ICartClient {
    createCart(request: CreateCartRequest | null): Promise<CartResponse | null>;
    updateCart(request: AddRecipesToCartCommand | null): Promise<Result | null>;
    getCart(cartId: string): Promise<CartResponse | null>;
}

export class CartClient extends ClientBase implements ICartClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    createCart(request: CreateCartRequest | null): Promise<CartResponse | null> {
        let url_ = this.baseUrl + "/api/Cart/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCart(_response);
        });
    }

    protected processCreateCart(response: Response): Promise<CartResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CartResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CartResponse | null>(<any>null);
    }

    updateCart(request: AddRecipesToCartCommand | null): Promise<Result | null> {
        let url_ = this.baseUrl + "/api/Cart/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCart(_response);
        });
    }

    protected processUpdateCart(response: Response): Promise<Result | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Result>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result | null>(<any>null);
    }

    getCart(cartId: string): Promise<CartResponse | null> {
        let url_ = this.baseUrl + "/api/Cart/rmm/{cartId}";
        if (cartId === undefined || cartId === null)
            throw new Error("The parameter 'cartId' must be defined.");
        url_ = url_.replace("{cartId}", encodeURIComponent("" + cartId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCart(_response);
        });
    }

    protected processGetCart(response: Response): Promise<CartResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CartResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CartResponse | null>(<any>null);
    }
}

export interface IDiscountClient {
    loadDetail(request: DiscountDetailRequest | null): Promise<Discount2 | null>;
}

export class DiscountClient extends ClientBase implements IDiscountClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    loadDetail(request: DiscountDetailRequest | null): Promise<Discount2 | null> {
        let url_ = this.baseUrl + "/api/Discount/detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoadDetail(_response);
        });
    }

    protected processLoadDetail(response: Response): Promise<Discount2 | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Discount2>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Discount2 | null>(<any>null);
    }
}

export interface IndexModel {
    productOption?: ProductOption | undefined;
    subscription?: SubscriptionDetailRequest | undefined;
    orderSummary?: OrderSummary | undefined;
    customer?: CustomerDetailRequest | undefined;
    cart?: CartReference | undefined;
    brandSettings?: BrandSettingModel | undefined;
    ui?: UiState | undefined;
    deliveryDates?: DeliveryDateSet | undefined;
    extras?: ProductOption[] | undefined;
    features?: FeaturesModel | undefined;
}

export interface ProductOption {
    sku?: string | undefined;
    name?: string | undefined;
    price: number;
    delivery: number;
    brand: Brand;
    quantity: number;
    requiredSelectionCount: number;
    numberOfPeopleToFeed: number;
    availableFrequency: AvailableFrequency;
    recipeSelectionMode: RecipeSelectionMode;
    imageUrl?: string | undefined;
}

export enum Brand {
    MyFoodBag = 1, 
    BargainBox = 2, 
    FreshStart = 4, 
    ReadyMadeMeals = 8, 
}

export enum AvailableFrequency {
    Weekly = 1, 
    Fortnightly = 2, 
    OneOff = 4, 
    FourWeekly = 8, 
}

export enum RecipeSelectionMode {
    None = 0, 
    Single = 1, 
    Multiple = 2, 
}

export interface SubscriptionDetailRequest {
    productOptionSku: string;
    discountCode?: string | undefined;
    deliveryDateId: string;
    overrideDeliverySlotId?: number | undefined;
    frequency: Frequency;
    cartId: string;
    campaignCode?: string | undefined;
    isOneOffBufferSale?: boolean | undefined;
    shouldUseDefaultCreditCard: boolean;
}

export enum Frequency {
    Weekly = 1, 
    Fortnightly = 2, 
    OneOff = 3, 
    FourWeekly = 4, 
}

export interface OrderSummary {
    subtotal: number;
    shipping: number;
    total: number;
}

export interface CustomerDetailRequest {
    firstName: string;
    lastName: string;
    email: string;
    password?: string | undefined;
    mobileNumber: string;
    addressId: number;
    pafId?: number | undefined;
    deliveryInstructions?: string | undefined;
    leadSource: LeadSource;
    address?: string | undefined;
    customerNumber?: string | undefined;
    creditCards?: CardDetails[] | undefined;
    isExistingCustomer: boolean;
}

export enum LeadSource {
    Mfb = 0, 
    Bb = 1, 
    Admin = 2, 
    Marketing = 3, 
    Orderform = 4, 
    Outgrow = 5, 
    Blog = 6, 
    Unbounce = 7, 
    InvolveMe = 8, 
    Shop = 9, 
    Business = 10, 
    Signup = 11, 
}

export interface CardDetails {
    cardId: number;
    cardNumber?: string | undefined;
    cardHolderName?: string | undefined;
    cardType?: string | undefined;
    expiryDate?: string | undefined;
    isDefault: boolean;
}

export interface CartReference {
    cartId?: string | undefined;
    cartType?: string | undefined;
    cartLines?: CartLine[] | undefined;
}

export interface CartLine {
    sku?: string | undefined;
    quantity: number;
    preferenceIds?: number[] | undefined;
    selectedRecipes?: CartRecipeSelection[] | undefined;
}

export interface CartRecipeSelection {
    recipeNumber?: string | undefined;
    recipeVersion?: string | undefined;
    recipePartition?: string | undefined;
    recipeCategoryCode?: string | undefined;
    recipeCategoryId: number;
    quantity: number;
}

export interface BrandSettingModel {
    gtmSetting?: GtmSetting | undefined;
    marketingSiteAddress?: string | undefined;
}

export interface GtmSetting {
    containerId?: string | undefined;
    brand: Brand;
    isEnabled: boolean;
}

export interface UiState {
    isReadOnlyForm: boolean;
    inputs?: Inputs | undefined;
    nzPostRecoveryRedirectAddress?: string | undefined;
}

export interface Inputs {
    addressMessage?: string | undefined;
}

export interface DeliveryDateSet {
    slots?: DeliverySlotResponse[] | undefined;
    dates?: DeliveryDateResponse[] | undefined;
    addressMessage?: string | undefined;
    upcomingDeliveryWeek: Date;
}

export interface DeliverySlotResponse {
    id?: string | undefined;
    description?: string | undefined;
}

export interface DeliveryDateResponse {
    id?: string | undefined;
    description?: string | undefined;
    weekStarting: Date;
    lateSale: boolean;
    isPublicHolidaySlot: boolean;
    isBufferWeek: boolean;
    actualDeliveryDate: Date;
    actualDeliveryStartTime: string;
    actualDeliveryEndTime: string;
}

export interface FeaturesModel {
    nzPostRecoveryMode: boolean;
    enablePlanYourWeekInOrderForm: boolean;
}

export interface AddressSuggestionResponse {
    addressId?: number | undefined;
    address?: string | undefined;
}

export interface AddressSummary {
    addressId?: AddressId | undefined;
    deliveryAreaId?: DeliveryAreaId | undefined;
    isEmpty: boolean;
}

export interface AddressId {
    value: number;
    pafId: number;
}

export interface DeliveryAreaId {
    value: number;
    isEmpty: boolean;
}

export interface DraftLeadResponse {
    customerNumber?: string | undefined;
}

export interface DraftLeadPayload {
    email?: string | undefined;
    password?: string | undefined;
    primaryProductSku?: string | undefined;
    cartId?: string | undefined;
    cartType?: string | undefined;
    customerContactPreference?: CustomerContactPreference | undefined;
}

export enum CustomerContactPreference {
    ExcludeMarketingEmailContact = 1, 
    ExcludeMarketingMobileSmsContact = 2, 
    ExcludeMobileAppReminders = 4, 
    ExcludeMobileAppAccountRelated = 8, 
    ExcludeMobileAppDeliveryInformation = 16, 
    ExcludeMobileAppSpecialOffersAndPromotions = 32, 
    ExcludeMobileAppSupport = 64, 
    ExcludeDirectMail = 128, 
    ExcludeOutboundCalling = 256, 
}

export interface ProductResponse {
    price?: ProductPriceResponse | undefined;
    name?: string | undefined;
    description?: string | undefined;
    id: number;
    productOptionId: number;
    productOptionSku?: string | undefined;
    brand: Brand;
    type: ProductType;
}

export interface ProductPriceResponse {
    price: number;
    delivery: number;
}

export enum ProductType {
    Primary = 1, 
    Extra = 2, 
    Donation = 3, 
    OneOff = 4, 
}

export interface ProductOptionStockAvailability {
    sku?: string | undefined;
    hasStockAvailable: boolean;
    numberOfPeopleToFeed?: number | undefined;
}

export interface ProductOptionResponse {
    sku?: string | undefined;
    name?: string | undefined;
    productType: ProductType2;
    price?: Money | undefined;
}

export enum ProductType2 {
    Primary = 1, 
    Extra = 2, 
    Donation = 3, 
    OneOff = 4, 
    Service = 5, 
    Promotional = 6, 
}

export interface Money {
    value: number;
}

export interface MultipleSkuRequest {
    skus?: string[] | undefined;
}

export interface PurchaseResponse {
    redirectUri?: string | undefined;
    subscriptionNumber: string;
}

export interface SubscriptionRequest {
    subscription: SubscriptionDetailRequest;
    customer: CustomerDetailRequest;
    discountCode?: string | undefined;
    voucherCode?: string | undefined;
    preferenceIds?: number[] | undefined;
}

export enum CreateSubscriptionErrorCode {
    LeadAlreadyExists = 10001, 
    BufferHasBeenConsumed = 20001, 
    VoucherHasBeenConsumed = 30001, 
}

export interface ValidateCodeResponse {
    voucher?: VoucherDto | undefined;
    promo?: PromoDto | undefined;
    raf?: ReferAFriendDto | undefined;
    discount?: Discount | undefined;
    validationErrors?: string[] | undefined;
}

export interface VoucherDto {
    voucherId: number;
    code?: string | undefined;
    value: number;
}

export interface PromoDto {
    code?: string | undefined;
    message?: string | undefined;
    discountType: DiscountType;
    benefits?: BenefitDto[] | undefined;
    promoGroupId: number;
    forNewOrReturningCustomers: boolean;
    validForProducts?: ProductSummary[] | undefined;
    redeemableFrom: Date;
    redeemableTo: Date;
    bannerUrlSmall?: string | undefined;
    bannerUrlMedium?: string | undefined;
    bannerUrlLarge?: string | undefined;
}

export enum DiscountType {
    Promo = 0, 
    RaF = 1, 
    PromoGroup = 2, 
}

export interface BenefitDto {
    benefitType: BenefitType;
    amount: number;
    message?: string | undefined;
    product?: ProductSummary | undefined;
    consumableFrom: Date;
    consumableTo?: Date | undefined;
    addProductBenefits?: AddProductBenefitDto[] | undefined;
    priceBenefits?: PriceBenefitDto[] | undefined;
}

export enum BenefitType {
    ValueOff = 0, 
    PercentageOff = 1, 
    FixedPrice = 2, 
}

export interface ProductSummary {
    name?: string | undefined;
    productOptionName?: string | undefined;
    productName?: string | undefined;
    sku?: string | undefined;
    itemNumber?: string | undefined;
    numberOfPlates?: number | undefined;
    totalPrice: number;
    deliveryPrice?: number | undefined;
}

export interface AddProductBenefitDto {
    product?: ProductSummary | undefined;
    overridePrice: number;
}

export interface PriceBenefitDto {
    benefitType: BenefitType;
    benefitValue: number;
    selector?: string | undefined;
    productSelectorType: ProductSelectorType;
}

export enum ProductSelectorType {
    All = 0, 
    Sku = 1, 
    Collection = 2, 
    PrimaryCollection = 3, 
    KitchenCollection = 4, 
    GourmetMeal = 5, 
}

export interface ReferAFriendDto {
    code?: string | undefined;
    message?: string | undefined;
    discountType: DiscountType;
    benefits?: BenefitDto[] | undefined;
    referredBy?: CustomerSummary | undefined;
}

export interface CustomerSummary {
    customerNumber?: string | undefined;
    fullName?: string | undefined;
}

export interface Discount {
    code?: string | undefined;
    discountType: DiscountType;
    message?: string | undefined;
    benefits?: BenefitDto[] | undefined;
}

export interface CalculateCostResponse {
    subtotal: number;
    discount?: DiscountResponse | undefined;
    voucher?: VoucherResponse | undefined;
    shippingTotal: number;
    total: number;
    totalDiscount: number;
}

export interface DiscountResponse {
    code?: string | undefined;
    message?: string | undefined;
    valueOff: number;
    product?: ProductSummary | undefined;
    productSummaries?: AddedProductSummaryDto[] | undefined;
}

export interface AddedProductSummaryDto {
    sku?: string | undefined;
    name?: string | undefined;
    retailPrice: number;
    isFree: boolean;
}

export interface VoucherResponse {
    code?: string | undefined;
    valueOff: number;
    balance: number;
}

export interface CalculateCostRequestBody {
    cartId: string;
    sku?: string | undefined;
    discountCode?: string | undefined;
    discountType?: DiscountType | undefined;
    voucherCode?: string | undefined;
    addressId?: number | undefined;
    frequency: Frequency2;
}

export enum Frequency2 {
    Weekly = 1, 
    Fortnightly = 2, 
    OneOff = 3, 
    FourWeekly = 4, 
}

export interface VoucherPaymentRedirectResponse {
    paymentUrl?: string | undefined;
}

export interface CreateVoucherRequest {
    quantity: number;
    voucherAmount: number;
    suggestedProductOptionSku?: string | undefined;
    purchaserFirstName?: string | undefined;
    purchaserLastName?: string | undefined;
    purchaserEmail?: string | undefined;
    redirectUrl?: string | undefined;
}

export interface VoucherPaymentResult {
    isSuccess: boolean;
    response?: string | undefined;
    voucherGroupId?: string | undefined;
}

export interface RecipeResponse {
    productName?: string | undefined;
    deliveryWeek: Date;
    recipes?: GridRecipe[] | undefined;
    deliveryDateDescription?: string | undefined;
}

export interface GridRecipe {
    name?: string | undefined;
    description?: string | undefined;
    imageUrl?: string | undefined;
    recipeCategoryId: number;
    quantity: number;
    protein?: number | undefined;
    sodium?: number | undefined;
    carbohydrateSugar?: number | undefined;
    carbohydrate?: number | undefined;
    saturatedFat?: number | undefined;
    fat?: number | undefined;
    energy?: number | undefined;
    ingredients?: string | undefined;
    allergens?: string | undefined;
    cookTime?: number | undefined;
    numberOfServes?: string | undefined;
    recipeId?: number | undefined;
    recipeNumber?: string | undefined;
    recipeVersion?: string | undefined;
    recipePartition?: string | undefined;
    recipeGroupRecipeId: string;
    sortOrder: number;
    recipeBadgeNames?: string[] | undefined;
    recipeTagNames?: string[] | undefined;
}

export interface RecipeDto {
    imageUrl?: string | undefined;
    title?: string | undefined;
    subtitle?: string | undefined;
    readyInTime?: number | undefined;
    recipeNumber?: string | undefined;
    recipePartition?: string | undefined;
    recipeVersion?: string | undefined;
    badge?: string | undefined;
    tags?: string[] | undefined;
    stockAvailability: StockAvailability;
    recipeCategoryId?: number | undefined;
    recipeCategoryCode?: string | undefined;
    unitSurcharge?: number | undefined;
    quantity: number;
    isDefaultRecipe: boolean;
}

export enum StockAvailability {
    NoStock = 0, 
    LowStock = 1, 
    HighStock = 2, 
}

export interface RecipeDetailResponse {
    name?: string | undefined;
    description?: string | undefined;
    numberOfServes?: string | undefined;
    readyInTime?: string | undefined;
    badges?: string[] | undefined;
    tags?: string[] | undefined;
    imageUrl?: string | undefined;
    ingredientGroups?: IngredientGroup[] | undefined;
    legends?: string[] | undefined;
    nutritionalInfo?: string[] | undefined;
    steps?: RecipeStep[] | undefined;
    allergens?: string | undefined;
    disclaimer?: string | undefined;
    unitSurcharge?: number | undefined;
}

export interface IngredientGroup {
    name?: string | undefined;
    ingredients?: string[] | undefined;
}

export interface RecipeStep {
    header?: string | undefined;
    detail?: string | undefined;
}

export interface RecipeDetailResponse2 {
    recipeNumber?: string | undefined;
    recipeVersion?: string | undefined;
    recipePartition?: string | undefined;
    allergens?: string[] | undefined;
    allergensContains?: string[] | undefined;
    allergensMayContain?: string[] | undefined;
    composition?: string | undefined;
    ingredientGroups?: IngredientGroupResponse[] | undefined;
    numberOfServes?: string | undefined;
    readyInTime?: number | undefined;
    badge?: string | undefined;
    tags?: string[] | undefined;
    description?: string | undefined;
    sortOrder?: number | undefined;
    type?: string | undefined;
    categoryCode?: string | undefined;
    imageUrl?: string | undefined;
    brand?: string | undefined;
    subtitle?: string | undefined;
    title?: string | undefined;
    recipeDocumentId?: string | undefined;
    steps?: StepResponse[] | undefined;
    nutritionalInformation?: NutritionResponse[] | undefined;
    surcharge?: RecipePricingResponse | undefined;
    recipeCardStyleName?: string | undefined;
    maximumQuantity: number;
    consumption?: string | undefined;
    recipeId?: string | undefined;
    version?: string | undefined;
    partitionKey?: string | undefined;
}

export interface IngredientGroupResponse {
    name?: string | undefined;
    ingredients?: IngredientResponse[] | undefined;
}

export interface IngredientResponse {
    ingredientType: IngredientType;
    description?: string | undefined;
    allergensContains?: string | undefined;
    allergensMayContain?: string | undefined;
}

export enum IngredientType {
    Other = 0, 
    Staple = 1, 
    Shared = 2, 
}

export interface StepResponse {
    number: number;
    heading?: string | undefined;
    method?: string | undefined;
}

export interface NutritionResponse {
    code?: string | undefined;
    label?: string | undefined;
    value?: number | undefined;
    unit?: string | undefined;
}

export interface RecipePricingResponse {
    listPrice?: ItemDisplayPriceResponse | undefined;
    salePrice?: SaleDisplayPriceResponse | undefined;
    hasDiscount: boolean;
}

export interface ItemDisplayPriceResponse {
    itemPrice: number;
    deliveryPrice: number;
    totalPrice: number;
    serves: number;
    itemPricePerServe: number;
    totalPricePerServe: number;
}

export interface SaleDisplayPriceResponse {
    itemPrice: number;
    deliveryPrice: number;
    totalPrice: number;
    serves: number;
    itemPricePerServe: number;
    totalPricePerServe: number;
    hasDiscount: boolean;
    discountSource: DiscountSource;
    promoCodeApplied?: string | undefined;
}

export enum DiscountSource {
    None = 0, 
    Other = 1, 
    CustomerPerpetualDiscount = 2, 
    PromoCode = 3, 
}

export interface CartResponse {
    id?: string | undefined;
    lines?: CartLine[] | undefined;
    lastUpdatedUtc: Date;
    createdDateUtc: Date;
}

export interface CreateCartRequest {
    lines?: CartLine[] | undefined;
}

export interface Result {
    succeeded: boolean;
    message?: string | undefined;
    errors?: string[] | undefined;
}

export interface AddRecipesToCartCommand {
    cartId: string;
    sku?: string | undefined;
    recipeSelections?: CartRecipeSelection2[] | undefined;
}

export interface CartRecipeSelection2 {
    recipeNumber?: string | undefined;
    recipeVersion?: string | undefined;
    recipePartition?: string | undefined;
    recipeCategoryCode?: string | undefined;
    recipeCategoryId: number;
    quantity: number;
}

export interface Discount2 {
    id?: number | undefined;
    code?: string | undefined;
    description?: string | undefined;
    valueOff: number;
    discountType?: DiscountType2 | undefined;
    valueOffType: ValueOffType;
    restrictions?: string[] | undefined;
    redeemableFrom?: Date | undefined;
    redeemableTo?: Date | undefined;
}

export enum DiscountType2 {
    Promo = 0, 
    PromoGroup = 1, 
    Voucher = 2, 
    Perpetual = 3, 
    Referral = 4, 
    CustomerBalance = 5, 
}

export enum ValueOffType {
    Percentage = 0, 
    Value = 1, 
    FreeProduct = 2, 
    Unknown = -1, 
}

export interface DiscountDetailRequest {
    code?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}